var _g, _path, _path2, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCancelledPinIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 52,
    viewBox: "0 0 46 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1438_17038)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.2857 8C15.4286 8 9 14.4286 9 22.2857C9 26 10.4286 29.7143 13.1429 32.4286L22.2857 41.8571C22.8571 42.4286 23.7143 42.4286 24.2857 41.8571L33.2857 32.4286C36.1429 29.7143 37.5714 26.1429 37.5714 22.2857C37.5714 14.4286 31.1429 8 23.2857 8Z",
    fill: "#D95945"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2861 7.25C31.5573 7.25023 38.3213 14.0149 38.3213 22.2861C38.3212 26.3369 36.8171 30.1089 33.8027 32.9727L24.8281 42.375L24.8223 42.3809L24.8164 42.3877C23.9522 43.2519 22.6202 43.2517 21.7559 42.3877L21.7471 42.3789L12.6123 32.958V32.959C9.74964 30.0963 8.25011 26.1877 8.25 22.2861C8.25 14.0148 15.0148 7.25 23.2861 7.25Z",
    stroke: "white",
    strokeWidth: 1.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.6018 28.3268C29.9661 28.6911 29.9661 29.2375 29.6018 29.6018C29.4196 29.7839 29.2375 29.875 28.9643 29.875C28.6911 29.875 28.5089 29.7839 28.3268 29.6018L23.5 24.775L18.6732 29.6018C18.4911 29.7839 18.3089 29.875 18.0357 29.875C17.7625 29.875 17.5804 29.7839 17.3982 29.6018C17.0339 29.2375 17.0339 28.6911 17.3982 28.3268L22.225 23.5L17.3982 18.6732C17.0339 18.3089 17.0339 17.7625 17.3982 17.3982C17.7625 17.0339 18.3089 17.0339 18.6732 17.3982L23.5 22.225L28.3268 17.3982C28.6911 17.0339 29.2375 17.0339 29.6018 17.3982C29.9661 17.7625 29.9661 18.3089 29.6018 18.6732L24.775 23.5L29.6018 28.3268Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1438_17038",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 18,
    width: 11,
    height: 11
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2459 27.254C28.5292 27.5373 28.5292 27.9623 28.2459 28.2457C28.1042 28.3873 27.9626 28.4582 27.7501 28.4582C27.5376 28.4582 27.3959 28.3873 27.2542 28.2457L23.5001 24.4915L19.7459 28.2457C19.6042 28.3873 19.4626 28.4582 19.2501 28.4582C19.0376 28.4582 18.8959 28.3873 18.7542 28.2457C18.4709 27.9623 18.4709 27.5373 18.7542 27.254L22.5084 23.4998L18.7542 19.7457C18.4709 19.4623 18.4709 19.0373 18.7542 18.754C19.0376 18.4707 19.4626 18.4707 19.7459 18.754L23.5001 22.5082L27.2542 18.754C27.5376 18.4707 27.9626 18.4707 28.2459 18.754C28.5292 19.0373 28.5292 19.4623 28.2459 19.7457L24.4917 23.4998L28.2459 27.254Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1438_17038)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 15H32V32H15V15Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1438_17038",
    x: 0.7,
    y: 0.7,
    width: 45.1715,
    height: 50.8856,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1438_17038"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1438_17038",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelledPinIcon);
export default __webpack_public_path__ + "static/media/CancelledPinIcon.1e7682a79e1235c22f249f6462558a7e.svg";
export { ForwardRef as ReactComponent };